module.exports = __webpack_public_path__ + "static/media/rsz_1truckwithtrailer.4468d084.png";